
import { OrderInput, OrderWithCustomer } from '@/components/dashboard/orders/types/orderTypes';
import { supabaseAnonKey } from '@/lib/supabase/client';

export const createOrderViaEndpoint = async (orderData: OrderInput): Promise<OrderWithCustomer> => {
  try {
    console.log('API SERVICE: Préparation de l\'envoi des données de commande:', JSON.stringify(orderData, null, 2));
    console.log('API SERVICE: Type de shop_id:', typeof orderData.shop_id, 'Valeur:', orderData.shop_id);
    
    // Validation for UUID fields
    if (!orderData.organization_id || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(orderData.organization_id)) {
      throw new Error('Invalid organization_id format');
    }
    
    // Clone the order data to avoid mutating the original
    const transformedOrderData = {
      ...orderData,
      // Ensure shop_id is included and properly passed
      shop_id: orderData.shop_id || null,
      order_number: orderData.external_id, // Pass order_number for the new field
      customer_metadata: orderData.customer_metadata || {
        email: orderData.customer.email,
        phone: orderData.customer.phone,
        name: orderData.customer.name
      },
      shipping_metadata: orderData.shipping_metadata || {
        address: orderData.customer.address,
        country: orderData.customer.country,
        region: orderData.customer.region,
        municipality: orderData.customer.municipality
      },
      order_metadata: orderData.order_metadata || {},
      items: orderData.items.map(item => ({
        ...item,
        product_id: item.product_id
      }))
    };
    
    console.log('API SERVICE: Données transformées avec shop_id:', transformedOrderData.shop_id);
    console.log('API SERVICE: Données transformées avec order_number:', transformedOrderData.order_number);
    console.log('API SERVICE: Données transformées avec shipping_metadata:', transformedOrderData.shipping_metadata);
    
    // URL de la fonction edge
    const edgeFunctionUrl = 'https://eledlxtrcasnxjjarfti.supabase.co/functions/v1/create_order';
    
    console.log('API SERVICE: Appel de la fonction edge URL:', edgeFunctionUrl);
    console.log('API SERVICE: Token d\'authentification:', supabaseAnonKey ? 'Présent' : 'Manquant');
    
    // Création de l'objet Headers avec le token d'authentification
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${supabaseAnonKey}`,
    });
    
    console.log('API SERVICE: Headers configurés:', [...headers.entries()].map(([key]) => key).join(', '));
    console.log('API SERVICE: Contenu complet de la requête:', JSON.stringify(transformedOrderData));
    
    // Début de l'appel fetch avec tous les détails possibles
    console.log('API SERVICE: Début de la requête fetch...');
    
    const response = await fetch(edgeFunctionUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(transformedOrderData),
      cache: 'no-cache',  // Désactiver le cache
      credentials: 'same-origin',  // Inclure les cookies pour le même domaine
    });

    console.log('API SERVICE: Réponse status:', response.status);
    console.log('API SERVICE: Réponse headers:', [...response.headers.entries()].map(([key, value]) => `${key}: ${value}`).join(', '));
    
    // Tentative de récupération du corps de la réponse
    const responseText = await response.text();
    console.log('API SERVICE: Réponse brute:', responseText);
    
    let result;
    try {
      result = JSON.parse(responseText);
      console.log('API SERVICE: Réponse parsée:', result);
    } catch (parseError) {
      console.error('API SERVICE: Erreur de parsing JSON:', parseError);
      throw new Error(`Réponse invalide du serveur: ${responseText}`);
    }
    
    if (!response.ok) {
      console.error('API SERVICE: Erreur de la réponse du serveur:', result);
      throw new Error(result.error || `Erreur lors de la création de la commande: ${response.status}`);
    }

    if (!result.success) {
      console.error('API SERVICE: La réponse indique un échec:', result);
      throw new Error(result.error || 'Erreur lors de la création de la commande');
    }

    // Return the created order with customer info with explicit type casting
    const createdOrder: OrderWithCustomer = {
      id: result.order_id,
      customer_id: result.customer_id,
      organization_id: orderData.organization_id,
      order_date: new Date().toISOString(),
      total_amount: orderData.items.reduce((sum, item) => sum + (item.price * item.quantity), 0),
      status: "pending" as "pending",
      payment_status: "unpaid" as "unpaid",
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      order_items: orderData.items.map(item => ({
        id: '',
        name: item.product_name,
        price: item.price,
        quantity: item.quantity,
        total: item.price * item.quantity,
        product_id: item.product_id,
        product_name: item.product_name
      })),
      // Make sure to include the shop_id from the response
      shop_id: result.shop_id || orderData.shop_id,
      order_number: orderData.external_id, // Include order_number in response
      customer_name: result.customer_name, // Include customer name from response
      customer_metadata: result.customer_metadata || transformedOrderData.customer_metadata,
      shipping_metadata: result.shipping_metadata || transformedOrderData.shipping_metadata,
      order_metadata: result.order_metadata || transformedOrderData.order_metadata
    };
    
    console.log('API SERVICE: Commande créée avec succès:', createdOrder);
    return createdOrder;
  } catch (error) {
    console.error('API SERVICE: Erreur critique lors de l\'appel à create_order:', error);
    throw error;
  }
};
